import { useState } from 'react';
import { faqList } from '@/mocks/animeData';

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 px-4 py-12 md:px-6 md:py-16">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于更新频率、榜单机制与追更方式，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqList.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                >
                  <span className="text-sm font-bold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-300 ${
                      open ? 'rotate-180 bg-primary-100 text-primary-700' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 pb-4 text-sm leading-6 text-foreground-600 md:px-5">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}